// extracted by mini-css-extract-plugin
export var editButton = "_ms-0";